import logoBcit from 'src/assets/img/logo-bcit.png'
import logoGoit from 'src/assets/img/logo-goit.png'
import logoLmit from 'src/assets/img/logo-lmit.png'
import logoTmit from 'src/assets/img/logo-tmit.png'

// The page is a sequence of lists, so they live here as data: a new question is one entry, not
// one more branch in the JSX. Every entry names its translation keys by convention.

// Order is by how often each cause actually happens. Panel keys are stable, so a link like
// /aiutosale#moved can open the right panel later on.
export const TROUBLE_CAUSES = [
  { key: 'moved', paragraphs: ['body', 'action', 'note'] },
  { key: 'early', paragraphs: ['body'] },
  { key: 'late', paragraphs: ['body'] },
  { key: 'notInvited', paragraphs: ['body'] },
  { key: 'wrongSheet', paragraphs: ['body'] },
  { key: 'notManaged', paragraphs: ['body'] }
]

export const RULES = [
  { key: 'rooms', paragraphs: ['a'] },
  { key: 'time', paragraphs: ['a'] },
  { key: 'who', paragraphs: ['a'] },
  { key: 'ifNot', paragraphs: ['a1', 'a2'] },
  { key: 'twice', paragraphs: ['a'] },
  { key: 'noLonger', paragraphs: ['a'] }
]

// The gesture is the only thing that differs between the four companies. NFC first: it covers most
// of the sites. The badges sit beside the company name and never replace it, so they carry no alt
// text: the reader knows their own company, and three of the four badges are a wordmark that stops
// being legible at this size.
export const CHECKIN_METHODS = [
  { key: 'nfc', steps: 4, logos: [logoLmit, logoBcit] },
  { key: 'qr', steps: 4, logos: [logoTmit, logoGoit] }
]

export const EMAILS = ['booking', 'checkin', 'cancelled', 'notDone']

export const CONTACT_FIELDS = ['field1', 'field2']

export const TICKET_URL =
  'https://adeo.service-now.com/digitalportal?id=sc_cat_item&sys_id=c4be5f871be07210798b5421604bcb11'

// No photo of the door sheet exists yet. Set this to the imported image to show the block.
export const DOOR_PHOTO = null
